/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AccountSlugRouteImport } from './routes/$accountSlug/route'
import { Route as AccountSlugIndexImport } from './routes/$accountSlug/index'
import { Route as AccountSlugSubmissionIdIndexImport } from './routes/$accountSlug/$submissionId/index'
import { Route as AccountSlugSubmissionIdSignerImport } from './routes/$accountSlug/$submissionId/signer'
import { Route as AccountSlugSubmissionIdAdditionalTradeReferencesImport } from './routes/$accountSlug/$submissionId/additional-trade-references'
import { Route as TradeReferencesAccountSlugTrackingIdIndexImport } from './routes/trade-references/$accountSlug/$trackingId/index'
import { Route as AccountSlugSubmissionIdTokenIndexImport } from './routes/$accountSlug/$submissionId/$token/index'
import { Route as AccountSlugSubmissionIdSignerTokenTokenImport } from './routes/$accountSlug/$submissionId/signer-token/$token'
import { Route as AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport } from './routes/$accountSlug/$submissionId/additional-trade-references-token/$token'

// Create/Update Routes

const AccountSlugRouteRoute = AccountSlugRouteImport.update({
  id: '/$accountSlug',
  path: '/$accountSlug',
  getParentRoute: () => rootRoute,
} as any)

const AccountSlugIndexRoute = AccountSlugIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountSlugRouteRoute,
} as any)

const AccountSlugSubmissionIdIndexRoute =
  AccountSlugSubmissionIdIndexImport.update({
    id: '/$submissionId/',
    path: '/$submissionId/',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdSignerRoute =
  AccountSlugSubmissionIdSignerImport.update({
    id: '/$submissionId/signer',
    path: '/$submissionId/signer',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdAdditionalTradeReferencesRoute =
  AccountSlugSubmissionIdAdditionalTradeReferencesImport.update({
    id: '/$submissionId/additional-trade-references',
    path: '/$submissionId/additional-trade-references',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const TradeReferencesAccountSlugTrackingIdIndexRoute =
  TradeReferencesAccountSlugTrackingIdIndexImport.update({
    id: '/trade-references/$accountSlug/$trackingId/',
    path: '/trade-references/$accountSlug/$trackingId/',
    getParentRoute: () => rootRoute,
  } as any)

const AccountSlugSubmissionIdTokenIndexRoute =
  AccountSlugSubmissionIdTokenIndexImport.update({
    id: '/$submissionId/$token/',
    path: '/$submissionId/$token/',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdSignerTokenTokenRoute =
  AccountSlugSubmissionIdSignerTokenTokenImport.update({
    id: '/$submissionId/signer-token/$token',
    path: '/$submissionId/signer-token/$token',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute =
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport.update({
    id: '/$submissionId/additional-trade-references-token/$token',
    path: '/$submissionId/additional-trade-references-token/$token',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$accountSlug': {
      id: '/$accountSlug'
      path: '/$accountSlug'
      fullPath: '/$accountSlug'
      preLoaderRoute: typeof AccountSlugRouteImport
      parentRoute: typeof rootRoute
    }
    '/$accountSlug/': {
      id: '/$accountSlug/'
      path: '/'
      fullPath: '/$accountSlug/'
      preLoaderRoute: typeof AccountSlugIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/additional-trade-references': {
      id: '/$accountSlug/$submissionId/additional-trade-references'
      path: '/$submissionId/additional-trade-references'
      fullPath: '/$accountSlug/$submissionId/additional-trade-references'
      preLoaderRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/signer': {
      id: '/$accountSlug/$submissionId/signer'
      path: '/$submissionId/signer'
      fullPath: '/$accountSlug/$submissionId/signer'
      preLoaderRoute: typeof AccountSlugSubmissionIdSignerImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/': {
      id: '/$accountSlug/$submissionId/'
      path: '/$submissionId'
      fullPath: '/$accountSlug/$submissionId'
      preLoaderRoute: typeof AccountSlugSubmissionIdIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/additional-trade-references-token/$token': {
      id: '/$accountSlug/$submissionId/additional-trade-references-token/$token'
      path: '/$submissionId/additional-trade-references-token/$token'
      fullPath: '/$accountSlug/$submissionId/additional-trade-references-token/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/signer-token/$token': {
      id: '/$accountSlug/$submissionId/signer-token/$token'
      path: '/$submissionId/signer-token/$token'
      fullPath: '/$accountSlug/$submissionId/signer-token/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdSignerTokenTokenImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/$token/': {
      id: '/$accountSlug/$submissionId/$token/'
      path: '/$submissionId/$token'
      fullPath: '/$accountSlug/$submissionId/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdTokenIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/trade-references/$accountSlug/$trackingId/': {
      id: '/trade-references/$accountSlug/$trackingId/'
      path: '/trade-references/$accountSlug/$trackingId'
      fullPath: '/trade-references/$accountSlug/$trackingId'
      preLoaderRoute: typeof TradeReferencesAccountSlugTrackingIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AccountSlugRouteRouteChildren {
  AccountSlugIndexRoute: typeof AccountSlugIndexRoute
  AccountSlugSubmissionIdAdditionalTradeReferencesRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesRoute
  AccountSlugSubmissionIdSignerRoute: typeof AccountSlugSubmissionIdSignerRoute
  AccountSlugSubmissionIdIndexRoute: typeof AccountSlugSubmissionIdIndexRoute
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  AccountSlugSubmissionIdSignerTokenTokenRoute: typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  AccountSlugSubmissionIdTokenIndexRoute: typeof AccountSlugSubmissionIdTokenIndexRoute
}

const AccountSlugRouteRouteChildren: AccountSlugRouteRouteChildren = {
  AccountSlugIndexRoute: AccountSlugIndexRoute,
  AccountSlugSubmissionIdAdditionalTradeReferencesRoute:
    AccountSlugSubmissionIdAdditionalTradeReferencesRoute,
  AccountSlugSubmissionIdSignerRoute: AccountSlugSubmissionIdSignerRoute,
  AccountSlugSubmissionIdIndexRoute: AccountSlugSubmissionIdIndexRoute,
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute:
    AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute,
  AccountSlugSubmissionIdSignerTokenTokenRoute:
    AccountSlugSubmissionIdSignerTokenTokenRoute,
  AccountSlugSubmissionIdTokenIndexRoute:
    AccountSlugSubmissionIdTokenIndexRoute,
}

const AccountSlugRouteRouteWithChildren =
  AccountSlugRouteRoute._addFileChildren(AccountSlugRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/$accountSlug': typeof AccountSlugRouteRouteWithChildren
  '/$accountSlug/': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references': typeof AccountSlugSubmissionIdAdditionalTradeReferencesRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/trade-references/$accountSlug/$trackingId': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRoutesByTo {
  '/$accountSlug': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references': typeof AccountSlugSubmissionIdAdditionalTradeReferencesRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/trade-references/$accountSlug/$trackingId': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/$accountSlug': typeof AccountSlugRouteRouteWithChildren
  '/$accountSlug/': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references': typeof AccountSlugSubmissionIdAdditionalTradeReferencesRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId/': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token/': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/trade-references/$accountSlug/$trackingId/': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$accountSlug'
    | '/$accountSlug/'
    | '/$accountSlug/$submissionId/additional-trade-references'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token'
    | '/trade-references/$accountSlug/$trackingId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$accountSlug'
    | '/$accountSlug/$submissionId/additional-trade-references'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token'
    | '/trade-references/$accountSlug/$trackingId'
  id:
    | '__root__'
    | '/$accountSlug'
    | '/$accountSlug/'
    | '/$accountSlug/$submissionId/additional-trade-references'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId/'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token/'
    | '/trade-references/$accountSlug/$trackingId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AccountSlugRouteRoute: typeof AccountSlugRouteRouteWithChildren
  TradeReferencesAccountSlugTrackingIdIndexRoute: typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AccountSlugRouteRoute: AccountSlugRouteRouteWithChildren,
  TradeReferencesAccountSlugTrackingIdIndexRoute:
    TradeReferencesAccountSlugTrackingIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/$accountSlug",
        "/trade-references/$accountSlug/$trackingId/"
      ]
    },
    "/$accountSlug": {
      "filePath": "$accountSlug/route.tsx",
      "children": [
        "/$accountSlug/",
        "/$accountSlug/$submissionId/additional-trade-references",
        "/$accountSlug/$submissionId/signer",
        "/$accountSlug/$submissionId/",
        "/$accountSlug/$submissionId/additional-trade-references-token/$token",
        "/$accountSlug/$submissionId/signer-token/$token",
        "/$accountSlug/$submissionId/$token/"
      ]
    },
    "/$accountSlug/": {
      "filePath": "$accountSlug/index.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/additional-trade-references": {
      "filePath": "$accountSlug/$submissionId/additional-trade-references.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/signer": {
      "filePath": "$accountSlug/$submissionId/signer.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/": {
      "filePath": "$accountSlug/$submissionId/index.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/additional-trade-references-token/$token": {
      "filePath": "$accountSlug/$submissionId/additional-trade-references-token/$token.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/signer-token/$token": {
      "filePath": "$accountSlug/$submissionId/signer-token/$token.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/$token/": {
      "filePath": "$accountSlug/$submissionId/$token/index.tsx",
      "parent": "/$accountSlug"
    },
    "/trade-references/$accountSlug/$trackingId/": {
      "filePath": "trade-references/$accountSlug/$trackingId/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
